import { useHistory } from 'react-router'
import { isKbChatNlpModelProvider } from '@feedyou/utils'
import { BotId, UserId, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { createItemList } from '../../../lib/array'
import { useAccessLevel } from '../../../store/user'
import { showContext, showThoughts } from '../utils'
import { useUserRole, useAccessToken } from '../../../store/user/hooks'
import { DropdownMenuItem } from '../../../components/design-system/DropdownMenu'
import { useNlpModelById } from '../../../store/flow'

export function useQueryMenuItems(params: {
  queryId: string
  userId: UserId
  botId: BotId
  context?: string
  modelId?: NlpModelId
  commitUserFilter: () => void
}) {
  const history = useHistory()
  const token = useAccessToken() || ''
  const isAdmin = useUserRole() === 'admin'
  const model = useNlpModelById(params.modelId || '')
  const { callsList: canAccessCallsList } = useAccessLevel()

  return createItemList<DropdownMenuItem>([
    {
      condition: isAdmin && !!params.modelId && isKbChatNlpModelProvider(model),
      type: 'text',
      label: 'Show thoughts',
      onClick: event => {
        const { queryId, botId, modelId } = params
        showThoughts(botId, modelId!, queryId, token)
        event.stopPropagation()
      }
    },
    {
      condition: isAdmin && !!params.context,
      type: 'text',
      label: 'Show context',
      onClick: event => {
        showContext(params.context || '')
        event.stopPropagation()
      }
    },
    {
      condition: canAccessCallsList,
      type: 'text',
      label: 'Show transcript',
      onClick: () => {
        history.push(
          `/bots/${params.botId}/calls/user/${params.userId}/transcript?queryId=${params.queryId}`
        )
      }
    },
    {
      type: 'text',
      label: 'Filter this user',
      onClick: event => {
        params.commitUserFilter()
        event.stopPropagation()
      }
    }
  ])
}
